import en from "./en.i18n.json";
import tr from "./tr.i18n.json";

const webLocale = {
  en: {
    translation: en,
  },
  tr: {
    translation: tr,
  },
};

export default webLocale;
